var map = {
	"./BarbeTondeuse.jpeg": 49,
	"./CoupeEnfant.jpeg": 834,
	"./CoupeHommeBarbeRasageAncienne.jpeg": 560,
	"./CoupeHommeBarbeTondeuse.jpeg": 453,
	"./ImageSalon.jpeg": 258,
	"./ImageSalon1.jpeg": 189,
	"./PhotoAccueil.jpeg": 346,
	"./PhotoSalon.jpeg": 821,
	"./PrestationGroupe.jpeg": 29,
	"./RasageBarbeAncienne.jpeg": 466,
	"./Soins_visage.jpeg": 582,
	"./coupeEtudiante.jpeg": 149,
	"./coupeHomme.jpeg": 504,
	"./coupeTondeuse.jpeg": 631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;